import type { IncidentDetailResponse } from '@prerender/diagnostics-api';
import { useId } from 'react';

import { formatCountOfTotalOrAbsent } from './crawlerEvidenceFigures';
import EvidenceFigure from './EvidenceFigure';
import EvidenceNotes from './EvidenceNotes';
import { EVIDENCE_TITLE } from './EvidenceTable';
import { notFoundRenderFiguresOf } from './notFoundRenderFigures';
import UrlImpactFigure from './UrlImpactFigure';

type NotFoundRenderEvidenceProps = {
  incident: IncidentDetailResponse;
};

const isReadable = (evidence: Record<string, unknown>): boolean => notFoundRenderFiguresOf(evidence) !== null;

function NotFoundRenderEvidence({ incident }: NotFoundRenderEvidenceProps) {
  const titleId = useId();

  return (
    <section className="diagnostics-detail-section" aria-labelledby={titleId}>
      <h2 id={titleId} className="diagnostics-detail-section-title">
        {EVIDENCE_TITLE}
      </h2>
      <dl className="diagnostics-evidence-figures">
        <EvidenceFigure name="404 requests" help="Crawler requests answered 404, from cache or rendered">
          {formatCountOfTotalOrAbsent(incident.requestImpactCount, incident.requestTotalCount)}
        </EvidenceFigure>
        <UrlImpactFigure
          name="URLs that returned a 404"
          affectedUrlCount={incident.affectedUrlCount}
          crawledUrlCount={incident.crawledUrlCount}
        />
      </dl>
      <EvidenceNotes domains={incident.domains} isReadable={isReadable} />
    </section>
  );
}

export default NotFoundRenderEvidence;
